@if (this.applicationService.initialized) {
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h2>{{ "FORMS.NEW_ENERGY_CONSULT.TITLE" | translate }}</h2>
      </div>
    </div>
  </div>
} @else {
  <mat-spinner></mat-spinner>
}
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <ul>
        <li>{{ "FORMS.NEW_ENERGY_CONSULT.DESCRIPTION.STEPS.FIRST" | translate }}</li>
        <li>{{ "FORMS.NEW_ENERGY_CONSULT.DESCRIPTION.STEPS.SECOND" | translate }}</li>
        <li>{{ "FORMS.NEW_ENERGY_CONSULT.DESCRIPTION.STEPS.THIRD" | translate }}</li>
      </ul>
      <br />
      <form [formGroup]="formGroup">
        <div class="row">
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>{{ "FORMS.NEW_ENERGY_CONSULT.FIELDS.EMAIL" | translate }}</mat-label>
              <input matInput formControlName="email" placeholder="jan@gmail.com" type="email" />
              <app-error [control]="formGroup.controls['email']"></app-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>{{ "FORMS.NEW_ENERGY_CONSULT.FIELDS.FIRST_NAME" | translate }}</mat-label>
              <input matInput formControlName="firstName" placeholder="Jan" type="text" />
              <app-error [control]="formGroup.controls['firstName']"></app-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>{{ "FORMS.NEW_ENERGY_CONSULT.FIELDS.LAST_NAME" | translate }}</mat-label>
              <input matInput formControlName="lastName" placeholder="Jansen" type="text" />
              <app-error [control]="formGroup.controls['lastName']"></app-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <ng-container *appExcludeModule="'PHONE_NUMBER_REQUIRED'">
            <div class="col-12">
              <mat-checkbox class="mb-3" color="primary" formControlName="usePhoneNumber">{{ "FORMS.NEW_ENERGY_CONSULT.FIELDS.USE_PHONE_NUMBER" | translate }}</mat-checkbox>
            </div>
          </ng-container>
          @if (formGroup.controls.usePhoneNumber.value) {
            <div class="col-12">
              <mat-form-field appearance="outline" [hideRequiredMarker]="!phoneNumberRequired">
                <mat-label>{{ "FORMS.NEW_ENERGY_CONSULT.FIELDS.PHONE_NUMBER" | translate }}</mat-label>
                <input matInput formControlName="phoneNumber" type="tel" />
                <app-error [control]="formGroup.controls['phoneNumber']"></app-error>
              </mat-form-field>
            </div>
          }
        </div>
        <div class="row" formGroupName="address">
          <div class="col-4">
            <mat-form-field appearance="outline">
              <mat-label>{{ "FORMS.NEW_ENERGY_CONSULT.FIELDS.POSTAL_CODE" | translate }}</mat-label>
              <input matInput formControlName="postalCode" placeholder="1234AB" type="text" />
              <app-error [control]="addressFormGroup.controls.postalCode"></app-error>
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field appearance="outline">
              <mat-label>{{ "FORMS.NEW_ENERGY_CONSULT.FIELDS.HOUSE_NUMBER" | translate }}</mat-label>
              <input matInput formControlName="houseNumber" placeholder="12" type="text" />
              <app-error [control]="addressFormGroup.controls.houseNumber"></app-error>
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field appearance="outline">
              <mat-label>{{ "FORMS.NEW_ENERGY_CONSULT.FIELDS.HOUSE_NUMBER_SUFFIX" | translate }}</mat-label>
              <input matInput formControlName="houseNumberSuffix" placeholder="A" type="text" />
              <app-error [control]="addressFormGroup.controls.houseNumberSuffix"></app-error>
            </mat-form-field>
          </div>
        </div>
        @if (errorMessageTracker.addressFound === false) {
          <div class="row">
            <div class="col text-warning d-flex align-items-center pb-1"><mat-icon>warning</mat-icon>{{ "FORMS.NEW_ENERGY_CONSULT.ADDRESS_NOT_FOUND" | translate }}</div>
          </div>
        }
        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>{{ "FORMS.NEW_ENERGY_CONSULT.FIELDS.STREETNAME" | translate }}</mat-label>
              <input matInput formControlName="streetName" type="text" />
              <app-error [control]="formGroup.controls.streetName"></app-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>{{ "FORMS.NEW_ENERGY_CONSULT.FIELDS.TOWN" | translate }}</mat-label>
              <input matInput formControlName="town" type="text" />
              <app-error [control]="formGroup.controls.town"></app-error>
            </mat-form-field>
          </div>
        </div>
        <ng-container *appModule="'AREA_ACTIONS'">
          <ng-container *appExcludeModule="'HIDE_AREA_ACTIONS_NEW_REQUEST_PAGE'">
            <div class="row">
              @if (addressFormGroup.controls.postalCode.value?.length) {
                <div class="col pb-5">
                  @if (areaActionsDataFiltered.length) {
                    <p>{{ "TABLES.AREA_ACTIONS_OVERVIEW.INTRO" | translate }}</p>
                  }
                  @if (areaActionsDataFiltered.length && areaActionsData.length) {
                    <app-table id="AREA_ACTIONS_OVERVIEW" [data]="areaActionsDataFiltered" [headers]="areaActionsColumns"></app-table>
                  } @else {
                    @if (applicationService.loading) {
                      @if (!areaActionsData.length) {
                        <p>{{ "TABLES.AREA_ACTIONS_OVERVIEW.LOADING" | translate }}</p>
                      }
                      @if (!areaActionsData.length) {
                        <mat-spinner style="height: 2rem; width: 2rem"></mat-spinner>
                      }
                    }
                    @if (areaActionsData.length) {
                      <p>{{ "TABLES.AREA_ACTIONS_OVERVIEW.NOT_AVAILABLE" | translate }}</p>
                    }
                    @if (!areaActionsData.length) {
                      <p>{{ "TABLES.AREA_ACTIONS_OVERVIEW.NONE_AVAILABLE" | translate }}</p>
                    }
                  }
                  @if (messageSearchForMore) {
                    <p>{{ "TABLES.AREA_ACTIONS_OVERVIEW.SEARCH_MORE" | translate }}</p>
                  }
                </div>
              }
            </div>
          </ng-container>
        </ng-container>
        <ng-container *appModule="'SHOW_SPECIALTIES_NEW_REQUEST'">
          @if (allSpecialties.length > 1) {
            <div class="row">
              <div class="col-12">
                <mat-form-field appearance="outline">
                  <mat-label>{{ "FORMS.NEW_ENERGY_CONSULT.FIELDS.SPECIALIZATION" | translate }}</mat-label>
                  <mat-select formControlName="specialties">
                    @for (specialty of allSpecialties; track specialty) {
                      <mat-option [value]="specialty">{{ specialty.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          }
        </ng-container>
        <div class="row">
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>{{ "FORMS.NEW_ENERGY_CONSULT.FIELDS.EXTRA_MESSAGE.LABEL" | translate }}</mat-label>
              <textarea
                rows="3"
                [placeholder]="'FORMS.NEW_ENERGY_CONSULT.FIELDS.EXTRA_MESSAGE.PLACEHOLDER' | translate"
                matInput
                formControlName="extraMessage"
                type="text"
              ></textarea>
              <span class="charCounter">
                <span>{{ formGroup.controls.extraMessage.value?.length ?? 0 }}</span>
                @if (extraMessageSettings.display === "max" && extraMessageSettings.max !== null) {
                  <span> / {{ extraMessageSettings.max }}</span>
                }
                @if (extraMessageSettings.display === "min" && extraMessageSettings.min !== null) {
                  <span> / {{ extraMessageSettings.min }}</span>
                }
              </span>
              <app-error [control]="formGroup.controls['extraMessage']"></app-error>
            </mat-form-field>
          </div>
        </div>
        <ng-container *appIsRole="'coordinator'">
          <div class="row" *appModule="'DM'">
            <div class="col-12 mb-3">
              <mat-checkbox color="primary" formControlName="dm">DM</mat-checkbox>
            </div>
          </div>
        </ng-container>
        <div class="row" *appModule="'TIME_SLOTS_DAILY'">
          <div class="col-12">
            <hr />
            <app-time-slots-daily [formgroup]="formGroup"></app-time-slots-daily>
            <hr />
          </div>
        </div>
        <div class="row" *appModule="'TIME_SLOTS'">
          <div class="col-12">
            <hr />
            <h4 class="mb-3">{{ "FORMS.NEW_ENERGY_CONSULT.FIELDS.PREFERRED_TIME_SLOTS.PREFERRED_DATES" | translate }}</h4>
            <app-time-slots-input #timeSlotPicker [formgroup]="formGroup" [areaActionMessage]="areaActionMessage | async"></app-time-slots-input>
            <hr />
          </div>
        </div>
        @for (item of extraPropertiesFields; track $index) {
          <div class="row">
            <div class="col-12">
              <ng-template [appExtraPropertiesOutlet]="item" (created)="onFieldCreated($event)"></ng-template>
              <hr />
            </div>
          </div>
        }
      </form>
      <button mat-raised-button color="primary" [disabled]="!formGroup.valid || isExtraPropertiesInvalid()" (click)="saveNewEnergyConsultForm()">
        {{ "FORMS.NEW_ENERGY_CONSULT.SAVE" | translate }}
      </button>
    </div>
  </div>
</div>

<ng-template #popup>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md">
        <h3 class="title">{{ "FORMS.NEW_ENERGY_CONSULT.SUCCESS_MESSAGE" | translate }} 🎉</h3>
        <!-- <p>{{ "FORMS.NEW_ENERGY_CONSULT.SUCCESS_MESSAGE_DESCRIPTION_1" | translate }}</p> -->
        <p>{{ "FORMS.NEW_ENERGY_CONSULT.SUCCESS_MESSAGE_DESCRIPTION_2" | translate }}</p>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #areaRerouteDialog let-data="data">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md">
        @if (data.custom && data.custom.text) {
          <h3 class="title">{{ "FORMS.NEW_ENERGY_CONSULT.DIALOGS.CUSTOM." + (data.custom.title ?? "TITLE") | translate }}</h3>
          @for (text of data.custom.text; track text) {
            <p style="margin-bottom: 0">
              {{ "FORMS.NEW_ENERGY_CONSULT.DIALOGS.CUSTOM." + text | translate }}
            </p>
          }
        } @else {
          <h3 class="title">{{ "FORMS.NEW_ENERGY_CONSULT.DIALOGS.AREA_OUT_OF_SCOPE.TITLE" | translate }}</h3>
          <p style="margin-bottom: 0">
            {{ "FORMS.NEW_ENERGY_CONSULT.DIALOGS.AREA_OUT_OF_SCOPE.MESSAGE_1" | translate }}
          </p>
          @if (data.link && data.link?.url !== null) {
            <p>
              {{ "FORMS.NEW_ENERGY_CONSULT.DIALOGS.AREA_OUT_OF_SCOPE.MESSAGE_2" | translate }}
            </p>
            <a [href]="data.link.url" target="_blank">{{ data.link.value ?? "Link" }}</a>
          }
        }
      </div>
    </div>
  </div>
</ng-template>
